import {
  createContactNormalizationNodeDefinitions,
  createContactNormalizationTemplate,
} from "@/Utile/ncrmContactNormalizationWorkflow.mjs";

export const createWorkflowTemplates = (t) => [
  {
    key: "enrichment-of-data",
    name: t("ncrm.workflows.templates.enrichment.name"),
    description: t("ncrm.workflows.templates.enrichment.description"),
  },
  createContactNormalizationTemplate(t),
  {
    key: "mailjet-engagement",
    name: t("ncrm.workflows.templates.mailjetEngagement.name"),
    description: t("ncrm.workflows.templates.mailjetEngagement.description"),
  },
];

const createMailjetEngagementNodeDefinitions = (t) =>
  [
    ["mailjet-event-trigger", "mailjetTrigger", "mdi-email-open-outline", "primary"],
    ["contact-existence-check", "contactExistenceCheck", "mdi-account-search-outline", "info"],
    ["lead-presence-check", "leadPresenceCheck", "mdi-clipboard-search-outline", "warning"],
    ["ai-compatibility-check", "aiCompatibilityCheck", "mdi-robot-outline", "info"],
    ["mailjet-lead-add", "mailjetLeadAdd", "mdi-flag-plus-outline", "success"],
    ["telegram-notify", "telegramNotify", "mdi-send-outline", "success"],
  ].map(([key, i18nKey, icon, color]) => ({
    key,
    label: t(`ncrm.workflows.nodes.${i18nKey}.label`),
    description: t(`ncrm.workflows.nodes.${i18nKey}.description`),
    icon,
    color,
    statusKey: "planned",
  }));

export const createWorkflowNodeDefinitions = (t, templateKey = "enrichment-of-data") => {
  if (templateKey === "contact-normalization") return createContactNormalizationNodeDefinitions(t);
  if (templateKey === "mailjet-engagement") return createMailjetEngagementNodeDefinitions(t);
  return [
    ["external-form-widget", "externalForms", "mdi-form-select", "primary"],
    ["api-import", "apiImport", "mdi-api", "primary"],
    ["file-import", "fileImport", "mdi-file-document-outline", "primary"],
    ["duplicate-check", "duplicateCheck", "mdi-account-search-outline", "warning"],
    ["data-enrichment", "dataEnrichment", "mdi-auto-fix", "info"],
    ["crm-write", "crmWrite", "mdi-database-arrow-right-outline", "success"],
    ["lead-board-add", "leadBoardAdd", "mdi-flag-plus-outline", "success"],
  ].map(([key, i18nKey, icon, color]) => ({
    key,
    label: t(`ncrm.workflows.nodes.${i18nKey}.label`),
    description: t(`ncrm.workflows.nodes.${i18nKey}.description`),
    icon,
    color,
    statusKey: "ready",
  }));
};
